import { Component } from 'react';
import isEqual from 'lodash-es/isEqual';
import autoBind from 'react-autobind';

import { queryItemWatchlistParser } from '../../../../../helpers/watchlistHelperFunctions';
import withComponentName from '../../../../../decorators/withComponentName';
import { presentationsParamGenerate } from '../../../../../helpers/identifierParamHelpers';

import TypesSection from '../../../../SEO_pages/CommonComponent/TypesSection';

class WLTypesSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extraProps: '',
      companyLists: [],
    };
    autoBind(this);
  }

  componentDidMount() {
    const { companyLists, extraProps } = this.setExtraProps();
    this.setState({
      companyLists,
      extraProps,
    });
  }

  componentDidUpdate(prevProps) {
    const { activeWatchlistTopics } = this.props;
    if (!isEqual(activeWatchlistTopics, prevProps.activeWatchlistTopics)) {
      const { companyLists, extraProps } = this.setExtraProps();
      this.setState({
        companyLists,
        extraProps,
      });
    }
  }

  setExtraProps() {
    const { activeWatchlistTopics } = this.props;

    const filterCompany = activeWatchlistTopics
      .filter((f) => (f.entity_type === 'Stocks' || f.entity_type === 'Private Companies and Brands') && !f.hidden);

    const companyLists = [];
    const extraProps = [];
    for (let i = 0; i < filterCompany.length; i += 1) {
      const {
        id, query, name, tickers, slug: mainSlug,
      } = filterCompany[i];
      const { name: topicName } = query ? queryItemWatchlistParser(query) : { name };
      const identifiers = presentationsParamGenerate({
        name: topicName,
        tickers: (tickers || []),
        slug: mainSlug,
      });
      companyLists.push({
        id,
        topicName,
        identifiers,
      });
      extraProps.push(identifiers);
    }
    return {
      companyLists,
      extraProps: extraProps.join(','),
    };
  }

  render() {
    const { companyLists, extraProps } = this.state;
    const { isSingleTopic, isIR } = this.props;

    if (!extraProps) return null;

    return (
      <TypesSection
        isWatchlists
        identifierProps={extraProps}
        companyLists={companyLists}
        isSingleTopic={isSingleTopic}
        isIR={isIR}
      />
    );
  }
}

export default withComponentName(WLTypesSection);
